import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';
import {IGetStoresResponse} from '../CustomShopperStores/ICustomShopperStores';

export const endpointsMap: IEndpointsMap = {
	CREATE_RESERVATION: {
		path: 'reservations',
		method: 'POST'
	},
	GET_RESERVATIONS_STORE: {
		path: 'reservations/stores',
		method: 'GET'
	}
};

// Options
export interface ICreateReservationOptions extends IBaseFetchOptions {
	body : {
		firstName: string;
		lastName: string;
		email: string;
		salutation?: string;
		storeId: string;
		products: Array<string>;
		phoneCode?: string;
		phone?: string;
		message?: string;
	};
}

export interface IFindAvailableStoresOptions extends IBaseFetchOptions {
	parameters: {
		c_productId: string;
	};
}

// Response
export interface ICreateReservationResponse extends IBaseResponse {
	confirmMessage: string
}

export interface IFindAvailableStoresResponse extends IGetStoresResponse {}
